import type { BootstrapCatalog, SalesDraft, SupportActivity } from './types';

export const ACTIVITY_SUPPORT_STORE_ID = 'SALES_ACTIVITY_SUPPORT';

export function activitiesForDate(catalog: BootstrapCatalog, date: string): SupportActivity[] {
  return (catalog.support_activities || []).filter(activity => activity.active
    && activity.start_date <= date && activity.end_date >= date);
}

export function reconcileActivityDraft(draft: SalesDraft, _catalog: BootstrapCatalog, _today: string): SalesDraft {
  if (draft.phase !== 'EDITING') return draft; // Keep an accepted receipt's exact retry payload.
  const activityId = draft.store_id === ACTIVITY_SUPPORT_STORE_ID
    ? ACTIVITY_SUPPORT_STORE_ID
    : '';
  return (draft.activity_id || '') === activityId ? draft : { ...draft, activity_id: activityId };
}
